import { render, staticRenderFns } from "./ModifyMyRole.vue?vue&type=template&id=a5e3e8b8"
import script from "./ModifyMyRole.vue?vue&type=script&lang=js"
export * from "./ModifyMyRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports